import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ListViewContainer = styled.div`
  width: 100%;
  padding-top: 88px;
  height: 100%;
  display: flex;
  position: relative;

  ${({ hasForecasts }) => {
    if (!hasForecasts) {
      return css`
        filter: blur(4px);
      `;
    }
  }}
`;

export const ConsumptionFrequency = styled.button`
  padding: 12px 24px;
  border-radius: 20px;

  border: ${(props) => {
    const color = props.isDailyConsumption
      ? props.theme.label.colors.green
      : props.theme.label.colors.blue;

    return `2px solid ${color}`;
  }};

  background-color: ${(props) => {
    const color = props.isDailyConsumption
      ? props.theme.label.colors.lightGreen
      : props.theme.label.colors.lightBlue;

    return color;
  }};

  cursor: auto;
`;
